import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {DeleteRecapRequest} from './types'

export async function apiDeleteRecap(params: DeleteRecapRequest): Promise<void> {
  const apiData = getApiMetadata('scribe-recaps-api-data')
  const url = new URL(`${apiData.url}/${params.recapId}`, window.location.origin)
  url.searchParams.set('project_number', params.projectNumber.toString())
  url.searchParams.set('owner_type', params.ownerType)
  url.searchParams.set('owner_id', params.ownerIdentifier)

  await fetchJSONWith(url.toString(), {
    method: 'DELETE',
  })
}
